"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-eye-cross.tsx
var EyeCross = function EyeCross(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M15.9999 9.33333C19.6799 9.33333 22.6666 12.32 22.6666 16C22.6666 16.8667 22.4933 17.68 22.1866 18.44L26.0799 22.3333C28.0933 20.6533 29.6799 18.48 30.6533 16C28.3466 10.1467 22.6533 6 15.9866 6C14.1199 6 12.3333 6.33333 10.6799 6.93333L13.5599 9.81333C14.3199 9.50667 15.1333 9.33333 15.9999 9.33333ZM2.66659 5.69333L5.70659 8.73333L6.31992 9.34667C4.10659 11.0667 2.37325 13.36 1.33325 16C3.63992 21.8533 9.33325 26 15.9999 26C18.0666 26 20.0399 25.6 21.8399 24.88L22.3999 25.44L26.3066 29.3333L27.9999 27.64L4.35992 4L2.66659 5.69333ZM10.0399 13.0667L12.1066 15.1333C12.0399 15.4133 11.9999 15.7067 11.9999 16C11.9999 18.2133 13.7866 20 15.9999 20C16.2933 20 16.5866 19.96 16.8666 19.8933L18.9333 21.96C18.0399 22.4 17.0533 22.6667 15.9999 22.6667C12.3199 22.6667 9.33325 19.68 9.33325 16C9.33325 14.9467 9.59992 13.96 10.0399 13.0667ZM15.7866 12.0267L19.9866 16.2267L20.0133 16.0133C20.0133 13.8 18.2266 12.0133 16.0133 12.0133L15.7866 12.0267Z"
  }));
};

var _default = EyeCross;
exports.default = _default;